import * as React from 'react';
import Loader from './Loader';
import { ModuleLoaderContainer } from './Style';

export const SystemModuleLoader = (): JSX.Element => (
  <ModuleLoaderContainer>
    <Loader />
  </ModuleLoaderContainer>
);

export default SystemModuleLoader;
